import { InputNumber as CoreInputNumber, InputNumberProps } from "antd";
import { twMerge } from "tailwind-merge";

export type { InputNumberProps };

export function InputNumber({ className, ...rest }: InputNumberProps) {
  return (
    <CoreInputNumber className={twMerge("!w-full", className)} {...rest} />
  );
}
